import { render, staticRenderFns } from "./news.vue?vue&type=template&id=2e5aec8c&"
import script from "./news.vue?vue&type=script&lang=ts&"
export * from "./news.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports